"use strict";

module.exports = {
  strings: {
    pluginNameInstagram: 'Instagram'
  }
};